import { z } from "zod";
import { LIMITS } from "./limits.ts";

export const emailSchema = z
  .string({ error: "Informe o e-mail." })
  .trim()
  .toLowerCase()
  .min(1, "Informe o e-mail.")
  .max(LIMITS.email, "E-mail muito longo.")
  .pipe(z.email({ error: "Informe um e-mail válido." }));

// 8–128 Unicode characters (BLD-20), spaces allowed, no composition rules (DEC defaults). Not trimmed.
export const PASSWORD_HINT = `De ${LIMITS.passwordMin} a ${LIMITS.passwordMax} caracteres. Espaços são permitidos.`;
export const passwordSchema = z
  .string({ error: "Informe a senha." })
  .refine((v) => [...v].length >= LIMITS.passwordMin, `A senha precisa ter pelo menos ${LIMITS.passwordMin} caracteres.`)
  .refine((v) => [...v].length <= LIMITS.passwordMax, `A senha pode ter no máximo ${LIMITS.passwordMax} caracteres.`);

export const personNameSchema = z
  .string({ error: "Informe o nome." })
  .trim()
  .min(1, "Informe o nome.")
  .max(LIMITS.name, `Use no máximo ${LIMITS.name} caracteres.`);

export const loginSchema = z.object({
  email: emailSchema,
  password: z.string({ error: "Informe a senha." }).min(1, "Informe a senha.").max(LIMITS.passwordMax * 4),
});

export const requestResetSchema = z.object({ email: emailSchema });
export const resetPasswordSchema = z.object({ token: z.string().min(16).max(200), password: passwordSchema });
export const profileSchema = z.object({ name: personNameSchema });
export const changePasswordSchema = z.object({
  current_password: z.string().min(1, "Informe a senha atual.").max(LIMITS.passwordMax * 4),
  new_password: passwordSchema,
});

export interface UserDto {
  id: string;
  name: string;
  email: string;
}

export interface SessionDto {
  user: UserDto;
  csrf_token: string;
}
